import React from 'react';
import clsx from 'clsx';
import { Icon, IconType } from '@99designs/frontend-components/components/Icon';

interface Props {
    additionalClasses?: string[];
    linkAdditionalClasses?: string[];
    attributes?: object;
    linkAttributes?: object;
    url: string;
    icon?: IconType;
    iconVariations?: string[];
    label: object | string;
}

export default function TopLevelNavigationItem({
    url,
    icon,
    iconVariations = [],
    label,
    additionalClasses = [],
    linkAdditionalClasses = [],
    attributes = {},
    linkAttributes = {},
}: Props) {
    return (
        <div className={clsx('top-level-nav__item', ...additionalClasses)} {...attributes}>
            <a
                className={clsx('top-level-nav__item__link', ...linkAdditionalClasses)}
                href={url}
                {...linkAttributes}
            >
                {/* eslint-disable-next-line react/jsx-no-useless-fragment  */}
                <>
                    {icon && (
                        <Icon
                            type={icon}
                            variations={iconVariations.concat(['offset-right', 'inline'])}
                        />
                    )}
                    {label}
                </>
            </a>
        </div>
    );
}
